import { ProductOverviewTable } from '@/components';

export default {
  name: 'ProductOverview',
  components: {
    [ProductOverviewTable.name]: ProductOverviewTable,
  },
  props: {},
  data: () => ({
    search: '',
    snackbar: false,
    snackbarMessage: '',
  }),
  computed: {},
  methods: {
    createNewProduct() {
      this.$router.push({ name: 'product' });
    },
    showSnackbar(message) {
      if (message.response) {
        if (message.response.status === 400) {
          this.snackbarMessage = message.response.data;
        } else {
          this.snackbarMessage = 'Something went wrong';
        }
      } else {
        this.snackbarMessage = message;
      }

      this.snackbar = true;
    },
  },
  created() {
    this.$eventHub.$on('show-snackbar', this.showSnackbar);
  },
};
